import { reportRequest, ReportHistory, OEEHistory } from './dataTypes';
import { httpRequest, BASE_URL, downloadFile } from './api-shared';
import moment from 'moment';

const REPORTS_URL = 'cutReports';
const CSV_EXPORT_URL = 'download';

export const getRecordsApi = (request: reportRequest): Promise<ReportHistory[]> => {
    // Get formatted URL
    const url: string = formatReportURL(`${BASE_URL}/${REPORTS_URL}`, request);
    return httpRequest(url,
        'get'
    ).then(r => {
        if (r.success === true && r.data) {
            return r.data as ReportHistory[];
        } else {
            console.log("Error retrieving reports, " + r.error!.message)
            throw (r.error);
        }
    });
};

export const exportCSV = (reqData: reportRequest) => {
    // Can't download a file via AJAX so do some trickery
    let anchor = document.createElement("a");
    const url: string = formatReportURL(`${BASE_URL}/${REPORTS_URL}/${CSV_EXPORT_URL}`, reqData);
    downloadFile(url
    ).then(blobFile => {
        // Create a dummy url that contains the file as a blob
        let objectUrl = window.URL.createObjectURL(blobFile);

        // Set our dummy url as the HRef in our hidden anchor tag
        anchor.href = objectUrl;
        // Set the downloaded file name
        anchor.download = `${formatDate(reqData.startDate)}.csv`;
        // Click the hidden anchor tag to download the blobFile
        anchor.click();

        // Destroy the dummy URL
        window.URL.revokeObjectURL(objectUrl);
    });
}

export const getOEEApi = (request: reportRequest, setupTime: number): Promise<OEEHistory[]> => {
    // Get formatted URL
    var url: string = formatReportURL(`${BASE_URL}/${REPORTS_URL}/OEE`, request);
    url = `${url}${setupTime ? `&setup=${setupTime}` : ''}`;
    return httpRequest(url,
        'get'
    ).then(r => {
        if (r.success === true && r.data) {
            return r.data as OEEHistory[];
        } else {
            console.log("Error retrieving OEE Data, " + r.error!.message)
            throw (r.error);
        }
    });
};

const formatReportURL = (rootUrl: string, data: reportRequest): string => {

    const start: string = `start=${formatDate(data.startDate)}`;
    const end: string = data.endDate ? `&end=${formatDate(data.endDate)}` : '';
    const system: string = data.systemId ? `&sysId=${data.systemId}` : '';
    const org: string = data.org ? `&org=${data.org}` : '';
    const shiftStartTime: string = data.shiftStartTime ? `&shiftStart=${formatTime(data.shiftStartTime)}` : '';
    const shiftEndTime: string = data.shiftEndTime ? `&shiftEnd=${formatTime(data.shiftEndTime)}` : '';

    return `${rootUrl}?${start}${end}${org}${system}${shiftStartTime}${shiftEndTime}`;
}

// Returns only the YYYY-MM-DD from the provided date
const formatDate = (date: Date): string => {
    return moment(date).format("YYYY-MM-DD")
}

const formatTime = (date: Date): string => {
    return moment(date).format("HH:mm")
}